import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { SpinnerOverlay } from "../SpinnerOverlay";
import { RegularButton } from "../buttons/RegularButton";
import { PrimaryButton } from "../buttons/PrimaryButton";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  open: boolean;
  loading: boolean;
  title: string;
  iframeSrc: string;
  renderContent: (renderProps: {
    iframe: React.ReactNode;
    consent: React.ReactNode;
  }) => React.ReactNode;
  consentLabel: React.ReactNode;
  onCancel: () => void;
  onSubmit: () => void;
};

export function IframeApproveDialog(props: Props) {
  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    if (!props.open) {
      setChecked(false);
    }
  });

  const classes = useStyles({});

  const iframe = (
    <div className={classes.iframeWrapper}>
      <SpinnerOverlay show={!props.loading} />
      <iframe className={classes.iframe} src={props.iframeSrc} />
    </div>
  );

  const consent = (
    <div className={classes.consent} onClick={() => setChecked(!isChecked)}>
      <FormControlLabel
        control={<Checkbox checked={isChecked} />}
        label={props.consentLabel}
      />
    </div>
  );

  const content = props.renderContent({ iframe, consent });

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      scroll="body"
      open={props.open}
      classes={{ paper: classes.root }}
      onBackdropClick={props.onCancel}
      onEscapeKeyDown={props.onCancel}
    >
      <DialogTitle>{props.title}</DialogTitle>

      <DialogContent className={classes.content}>
        <SpinnerOverlay show={props.loading} />
        {content}
      </DialogContent>

      <DialogActions>
        <RegularButton onClick={props.onCancel}>{locale.Cancel}</RegularButton>
        <PrimaryButton disabled={!isChecked} onClick={props.onSubmit}>
          {locale.Next}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles(() => ({
  root: {},

  iframeWrapper: {
    flex: 1,
    display: "flex",
    position: "relative",
    minHeight: "80vh"
  },

  iframe: {
    border: 0,
    flex: 1,
    zIndex: 10
  },

  consent: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "antiquewhite"
  },

  content: {
    display: "flex",
    flexDirection: "column",
    position: "relative"
  }
}));
